module.exports = __webpack_public_path__ + "static/img/show1.33177d39.png";